/*
 * Mobile product gallery fix (iOS Safari).
 * - Main gallery images are injected by JS with loading="lazy"; inside the slick slider
 *   Safari never loads them. Force them to load eagerly as soon as they are inserted.
 * - Re-measure the slick slider once images/slider are ready so the slide gets its width.
 * Safe no-op on pages without the gallery.
 */
(function () {
  "use strict";

  function makeEager(root) {
    if (!root || root.nodeType !== 1) return;
    var imgs = [];
    if (root.matches && root.matches("img")) imgs.push(root);
    if (root.querySelectorAll) {
      Array.prototype.push.apply(imgs, root.querySelectorAll("img"));
    }
    imgs.forEach(function (img) {
      var container = img.closest && img.closest(".tps-main-image-slide");
      if (!container) return;
      var slide = img.closest(".tps-main-slide");
      var first = container.querySelector(".tps-main-slide:not(.slick-cloned)");
      // Only the first (visible) main image is loaded eagerly; the rest stay lazy.
      if (slide && slide === first) {
        if (img.getAttribute("loading") === "lazy") img.setAttribute("loading", "eager");
        img.setAttribute("fetchpriority", "high");
        img.setAttribute("decoding", "async");
      }
    });
  }

  function refreshSlick() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    $(".tps-main-image-slide.slick-initialized").each(function () {
      try {
        $(this).slick("setPosition");
      } catch (e) { /* slider not ready */ }
    });
  }

  // 1. Make lazy main images eager the moment the gallery HTML is injected.
  if ("MutationObserver" in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(makeEager);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener("DOMContentLoaded", function () {
    makeEager(document.body);
  });

  // 2. Re-measure the slider when a main image finishes loading (load does not bubble, so capture).
  document.addEventListener("load", function (e) {
    var t = e.target;
    if (t && t.tagName === "IMG" && t.closest && t.closest(".tps-main-image-slide")) {
      refreshSlick();
    }
  }, true);

  // 3. Re-measure after slick initialises and on resize / orientation change.
  document.addEventListener("DOMContentLoaded", function () {
    var $ = window.jQuery;
    if ($) {
      $(document).on("init reInit", ".tps-main-image-slide", function () {
        setTimeout(refreshSlick, 50);
      });
    }
  });
  window.addEventListener("load", function () { setTimeout(refreshSlick, 800); });
  window.addEventListener("orientationchange", function () { setTimeout(refreshSlick, 300); });
  window.addEventListener("resize", function () { setTimeout(refreshSlick, 200); });
})();